/* Gated datasheet downloads: popup capture -> Klaviyo event (primary lead
   store) -> file delivery. The Shopify customer POST is best-effort only:
   stores with spam protection enabled reject AJAX customer posts with
   400 "Missing CAPTCHA token", so it cannot be relied on for capture.
   With no Klaviyo key configured, success falls back to the Shopify result. */
(function () {
  'use strict';
  if (window.__dsDownloadsInit) return;
  window.__dsDownloadsInit = true;

  var LS_KEY = 'ds-lead';
  var modal = null;
  var current = null; // { url, name, productHandle, productTitle }

  function config() {
    var root = document.querySelector('.datasheet-downloads');
    return {
      klaviyoKey: ((root && root.getAttribute('data-ds-klaviyo')) || '').trim(),
      productHandle: root ? root.getAttribute('data-product-handle') : '',
      productTitle: root ? root.getAttribute('data-product-title') : ''
    };
  }

  function ensureModal() {
    if (modal && modal.isConnected) return modal;
    var tpl = document.querySelector('[data-ds-modal-template]');
    if (!tpl) return null;
    modal = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-ds-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
    return modal;
  }

  function open(ctx) {
    current = ctx;
    var m = ensureModal();
    if (!m) { window.open(ctx.url, '_blank'); return; }
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem(LS_KEY) || '{}'); } catch (e) {}
    m.querySelector('#ds-name').value = saved.name || '';
    m.querySelector('#ds-email').value = saved.email || '';
    m.querySelector('[data-ds-form]').hidden = false;
    m.querySelector('[data-ds-done]').hidden = true;
    m.querySelector('[data-ds-error]').hidden = true;
    m.hidden = false;
    document.documentElement.classList.add('ds-modal-open');
    m.querySelector(saved.name ? '#ds-email' : '#ds-name').focus();
  }

  function close() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('ds-modal-open');
  }

  function slug(s) {
    return String(s).toLowerCase().replace(/\.pdf$/, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  /* Resolves true (accepted), false (both attempts failed) or null (no key
     configured). One retry: a transient 5xx must not lose the lead. */
  function sendKlaviyo(cfg, name, email) {
    if (!cfg.klaviyoKey) return Promise.resolve(null);
    var parts = name.trim().split(/\s+/);
    var payload = {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: 'Downloaded Datasheet' } } },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: parts[0] || '',
                last_name: parts.slice(1).join(' '),
                properties: { sheet_downloaded: true, product: cfg.productTitle }
              }
            }
          },
          properties: {
            product: cfg.productTitle,
            product_handle: cfg.productHandle,
            datasheet: current.name,
            url: location.href
          }
        }
      }
    };
    var attempt = function () {
      return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(cfg.klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    };
    return attempt().then(function (ok) {
      if (ok) return true;
      return new Promise(function (res) { setTimeout(res, 1500); }).then(attempt);
    });
  }

  function onSubmit(e, form) {
    if (form.__dsBusy) return;
    var cfg = config();
    var name = form.querySelector('#ds-name').value.trim();
    var email = form.querySelector('#ds-email').value.trim();
    if (!name || !email) return;
    form.__dsBusy = true;
    var parts = name.split(/\s+/);
    form.querySelector('[data-ds-first]').value = parts[0];
    form.querySelector('[data-ds-last]').value = parts.slice(1).join(' ') || parts[0];
    form.querySelector('[data-ds-tags]').value = [
      'datasheet-download',
      'ds-product:' + cfg.productHandle,
      'ds-file:' + slug(current.name)
    ].join(', ');

    var btn = form.querySelector('.ds-modal__submit');
    btn.disabled = true;
    var label = form.querySelector('[data-ds-submit-label]');
    var prev = label.textContent;
    label.textContent = 'One moment…';

    var shopify = fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' }
    });

    Promise.allSettled([shopify, sendKlaviyo(cfg, name, email)]).then(function (results) {
      form.__dsBusy = false;
      btn.disabled = false;
      label.textContent = prev;
      var klaviyoOk = results[1].status === 'fulfilled' ? results[1].value : false;
      var failed;
      if (klaviyoOk === null) {
        var shopifyResult = results[0];
        failed = shopifyResult.status === 'rejected' ||
          (shopifyResult.value && shopifyResult.value.status >= 500);
      } else {
        failed = !klaviyoOk;
      }
      if (failed) {
        form.querySelector('[data-ds-error]').hidden = false;
        return;
      }
      try { localStorage.setItem(LS_KEY, JSON.stringify({ name: name, email: email })); } catch (err) {}
      form.hidden = true;
      var done = modal.querySelector('[data-ds-done]');
      done.hidden = false;
      done.querySelector('[data-ds-download-link]').href = current.url;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ds-open]');
    if (!btn) return;
    e.preventDefault();
    var cfg = config();
    open({
      url: btn.getAttribute('data-file-url'),
      name: btn.getAttribute('data-file-name'),
      productHandle: cfg.productHandle,
      productTitle: cfg.productTitle
    });
  });

  /* The gate form must never navigate. Two capture-phase, document-level
     guards — preventDefault runs before any other code (ours or the
     theme's) can act, so nothing can fall back to a native POST + page
     refresh:
     1. click on the submit button: validate + run the capture flow.
     2. submit on the form: backstop for Enter-key and any other path. */
  function runCapture(form) {
    try { onSubmit(null, form); } catch (err) {
      var errEl = form.querySelector('[data-ds-error]');
      if (errEl) errEl.hidden = false;
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.ds-modal__submit') : null;
    if (!btn) return;
    var form = btn.closest('[data-ds-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    if (form.reportValidity && !form.reportValidity()) return;
    runCapture(form);
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-ds-form]') : null;
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    if (form.reportValidity && !form.reportValidity()) return;
    runCapture(form);
  }, true);
})();
